<template>
  <div
    class="column justify-between"
    style="padding: 16px 16px 4px 16px; background-color: #f2f2f2"
  >
    <div class="column justify-between ">
      <div class="row justify-between items-center">
        <label for="title">
          <span class="label">Título</span>
          <FieldText
            :for-label="title"
            :value="title"
            v-model="title"
            max-length="48"
            :rules="[(title) => title.trim().length || 'Campo obrigatório']"
            style="width: 360px"
          />
        </label>
        <ButtonColors
          @update-color="updateBackgroundColor"
          :background-color="backgroundColor"
        />
      </div>
      <div style="margin-bottom: 16px">
        <label for="description">
          <span class="label">Descrição</span>
          <FieldText
            :for-label="description"
            :value="description"
            v-model="description"
            max-length="100"
          />
        </label>
      </div>
    </div>
    <div>
      <div>
        <label for="contact">
          <span class="label">Contato</span>
          <FieldText
            v-if="scheduleTemplate"
            :for-label="contact"
            :value="contact"
            v-model="contact"
            max-length="100"
            :rules="[(val) => val.trim().length > 0 || 'Campo obrigatório']"
          />
          <FieldText
            v-else
            :for-label="contact"
            :value="contact"
            v-model="contact"
            max-length="100"
            :rules="[false]"
          />
        </label>
      </div>
    </div>
    <div>
      <div
        class="row"
        style="height: 25px;"
      >
        <span class="label col-6">Horário de agendamento</span>
        <div class="q-mb-xs">
          <q-icon
            name="mdi-alert-circle"
            color="red-8"
            size="xs"
            class="q-mx-sm"
            v-if="invalidEndDate || dateBeforeNow ||agentisPaused"
          />
          <span
            class="text-red-8"
            style="font-size: 11px"
            v-if="(invalidEndDate || dateBeforeNow) && !agentisPaused"
          >{{ invalidEndDate? 'Horário final menor que o inicial' : "Horário menor que hora atual" }}</span>
          <span
            class="text-red-8"
            style="font-size: 11px"
            v-if="agentisPaused"
          >{{ 'Agente em pausa' }}</span>
        </div>
      </div>
      <div
        class="row justify-between items-baseline"
        style="height: 52px"
      >
        <FieldDateTime
          v-model="startDate"
          @validate="validateStartDate"
          style="width: 220px"
        />
        <span
          style="font-size: 20px;"
          class="q-mx-sm"
        >-</span>
        <FieldDateTime
          v-model="endDate"
          @validate="validateEndDate"
          style="width: 220px"
        />
      </div>
      <div style="margin-bottom: 16px">
        <span class="label">Tempo de antecedência do alerta</span>
        <FieldSelect
          :list="timeBeforeOptions.list"
          type="text"
          v-model="notificationTimeBefore"
        />
      </div>
      <div
        class="row justify-between items-center"
        style="margin-bottom: 8px"
      >
        <span class="provision">Envio de templates</span>
        <q-checkbox
          v-model="scheduleTemplate"
          rounded
          color="grey-8"
          checked-icon="mdi-minus-circle-outline"
          unchecked-icon="mdi-plus-circle-outline"
          :disable="editTemplate && Boolean(templateToSend.name)"
        />
      </div>

      <div
        class="row justify-between items-center"
        v-if="scheduleTemplate"
      >
        <ListBrokers
          @on-template-select="handleScheduleTemplate"
          :schedule-template="true"
          :disable-list="editTemplate && Boolean(templateToSend.name)"
        />
        <div class="column">
          <FieldText
            :value="templateToSend"
            v-model="templateToSend.name"
            max-length="100"
            style="width: 320px"
            :disabled="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment-timezone'
import FieldDateTime from './FieldDateTime.vue'
import ButtonColors from './ButtonColors.vue'
import { formatContact } from './utils/phones.js'
import FieldText from './FieldText.vue'
import FieldSelect from './FieldSelect.vue'
import ListBrokers from './ListBrokers.vue'
import AskTemplateParams from './AskTemplateParams.vue'
import AskTemplateQueue from '@/components/AskTemplateQueue'
import { toWhatsNumber } from '@/libs/startAttendance'
moment.locale('pt-br')

export default {
  components: {
    FieldDateTime,
    ButtonColors,
    FieldText,
    FieldSelect,
    ListBrokers
  },

  props: {
    agentId: {},
    date: {},
    attendance: { default: null },
    eventDetails: { default: null },
    editTemplate: { default: false },
    isPaused: { default: false }
  },

  data () {
    const eventCreated = this.eventDetails

    const startDate = moment(eventCreated ? this.eventDetails.start : this.date).unix()
    const endDate = moment(eventCreated ? this.eventDetails.end : this.date).add(eventCreated ? 0 : 1, 'hour').unix()

    let contact = eventCreated
      ? this.labelContact(this.eventDetails.contact)
      : ''

    if (this.attendance && !eventCreated) {
      this.attendanceInfo = JSON.parse(this.attendance)
      contact = this.labelAttendanceContact(this.attendanceInfo)
    }

    const notificationTimeBefore = eventCreated
      ? this.eventDetails?.notificationTimeBefore ?? 120
      : 120

    const templateToSend = eventCreated ? this.eventDetails?.templateToSend ?? { name: '' } : { name: '' }
    const scheduleTemplate = Boolean(templateToSend.name !== '')

    const backgroundColor = eventCreated ? this.eventDetails?.backgroundColor : '#7EC8E3'

    return {
      attendanceInfo: this.attendance,
      attendanceParsed: null,
      backgroundColor: backgroundColor,
      description: '',
      endDate: endDate,
      formError: this.handleDisable(),
      notificationTimeBefore: notificationTimeBefore,
      contact: contact,
      scheduleTemplate: scheduleTemplate,
      startDate: startDate,
      templateToSend: templateToSend,
      title: '',
      timeBeforeOptions: {
        value: 120,
        list: [
          { label: '2 minutos antes', id: 120 },
          { label: '5 minutos antes', id: 300 },
          { label: '10 minutos antes', id: 600 },
          { label: '30 minutos antes', id: 1800 },
          { label: '1 hora antes', id: 3600 }
        ]
      },
      validEndDate: true,
      validStartDate: true
    }
  },

  mounted () {
    if (this.eventDetails) {
      this.backgroundColor = this.eventDetails.backgroundColor
      this.description = this.eventDetails.description
      this.title = this.eventDetails.title
    }

    this.$emit('form-error', this.formHasError)
  },

  computed: {

    formHasError () {
      const invalidTitle = !this.title || this.title.trim().length < 1
      const invalidDateFormat = !this.validEndDate || !this.validStartDate
      const invalidDateRange = this.endDate < this.startDate
      const dateBeforeNow = this.startDate < moment().unix() || this.endDate < moment().unix()
      const invalidContactForTemplate = this.scheduleTemplate && (this.invalidContactNumber || this.templateToSend === '')
      const agentisPaused = this.isPaused
      return invalidTitle || invalidDateFormat || invalidDateRange || invalidContactForTemplate || dateBeforeNow || agentisPaused
    },

    invalidEndDate () {
      return this.endDate < this.startDate
    },

    dateBeforeNow () {
      return this.startDate < moment().unix()
    },

    agentisPaused () {
      return this.isPaused
    },

    invalidContactNumber () {
      if (!this.contact) return true
      const isEmpty = this.contact.trim() === ''
      const hasInvalidChars = !/^[0-9*]+$/.test(this.contact)
      const hasChars = !/^\d+$/.test(this.contact)
      const invalidcontact = this.contact.length < 8
      return isEmpty || hasInvalidChars || hasChars || invalidcontact
    },

    isChat () {
      return this.attendanceInfo?.channel === 'TEXT'
    },

    isMail () {
      return this.attendanceInfo?.channel === 'MAIL'
    },

    isVoice () {
      return this.attendanceInfo?.channel === 'VOICE'
    }

  },

  methods: {

    getFormData () {
      const formData = {
        title: this.title,
        description: this.description,
        contact: this.contact,
        startDate: this.startDate,
        endDate: this.endDate,
        backgroundColor: this.backgroundColor,
        notificationTimeBefore: this.notificationTimeBefore

      }

      if (this.scheduleTemplate) {
        const areaCode = this.$store.state.settingsModule?.provision?.areaCode || ''
        formData.contact = toWhatsNumber(this.contact, areaCode)
        formData.templateToSend = this.templateToSend
      }

      return formData
    },

    formatDate (date) {
      return moment(date).format('dddd, D [de] MMMM')
    },

    handleDisable () {
      const disableButton = true
      const invalidTitle = !this.title || this.title.trim().length < 1
      const invalidDate = !this.startDate || !this.endDate || !this.validEndDate || !this.validStartDate
      const invalidDateRange = this.endDate < this.startDate
      if (invalidDate || invalidTitle || invalidDateRange) return disableButton
      return false
    },

    handleScheduleTemplate (template) {
      const hasParams = template?.params?.length || template?.params?.params?.length
      const queues = Array.isArray(template.queues) ? template.queues.map(({ queueId, queueName }) => ({ id: queueId, label: queueName })) : []

      const agent = this.$store.state?.agentModule?.session?.agent

      if (hasParams) {
        this.$q.dialog({ parent: this, template, agent, schedule: true, component: AskTemplateParams }).onOk(({ queueId, fields, header }) => {
          template.queueId = queueId
          template.fields = fields
          template.header = header
        })
      }

      if (queues.length > 1 && !hasParams) {
        this.$q.dialog({ parent: this, template, agent, schedule: true, component: AskTemplateQueue }).onOk(({ queueId }) => {
          template.queueId = queueId
        })
      }

      this.templateToSend = template
    },

    labelContact (contactInfo) {
      if (!this.attendanceInfo) return contactInfo
      if (this.isChat) return this.attendanceInfo.sourceId
      if (this.isVoice) {
        const contact = contactInfo.split(/\D+/).join('')
        const areaCode = this.$store.state.settingsModule?.provision?.areaCode || ''
        return formatContact(contact, areaCode)
      }
      if (this.isMail) return this.attendanceInfo.to[0].id
      return ''
    },

    labelAttendanceContact (attInfo) {
      const channel = attInfo.channel
      if (channel === 'TEXT') return attInfo.sourceId
      if (channel === 'VOICE') {
        const contact = attInfo.contact.split(/\D+/).join('')
        const areaCode = this.$store.state.settingsModule?.provision?.areaCode || ''
        return formatContact(contact, areaCode)
      }
      if (channel === 'MAIL') return attInfo.to.map(({ id }) => id).join(', ')
      return ''
    },

    selectColor (option) {
      this.color = option
    },

    updateBackgroundColor (option) {
      this.backgroundColor = option
    },

    validateStartDate (isValid) {
      const invalidDateRange = this.endDate < this.startDate
      const dateBeforeNow = this.startDate < moment().unix()
      this.validStartDate = isValid || invalidDateRange || dateBeforeNow
    },

    validateEndDate (isValid) {
      const validDateRange = this.endDate > this.startDate
      const dateAfterNow = this.endDate > moment().unix()
      this.validEndDate = isValid || validDateRange || dateAfterNow
    }

  },

  watch: {
    formHasError (newVal) {
      this.$emit('form-error', newVal)
    },
    contact (contact) {
      this.$emit('update-contact', contact)
    },
    timeBeforeOptions (option) {
      this.notificationTimeBefore = option.value
    },

    endDate () {
      this.validateEndDate(true)
    }
  }
}

</script>
<style lang="sass">
  .label
    font-weight: normal
    font-size: 14px
</style>
